import type { SessionRecovery } from '@/shared/hooks/queries/useAuthMutations'

import { isEmbeddedContext } from './embedContext'
import {
  canRequestStorageAccess,
  requestStorageAccessOnce,
} from './storageAccess'

// 認証 (shared) が 401 から復帰するための手段を、AnyCOMPASS 埋め込み向けに実装したもの。
//
// 依存の向きに注意。shared → features ではなく **features → shared** になっている。
// 認証側は「復帰手段が注入されたか」しか知らず、それが Storage Access API であることも
// AnyCOMPASS の話であることも知らない。注入するのは App.tsx (ゲート) と
// pages/login.tsx (文言の出し分け) で、どちらも feature を import してよい層。
//
// module 定数にしているのは参照の同一性のため (useCheckAuthQuery 側で useCallback の
// 依存に入る)。毎回オブジェクトを作って渡さないこと。
export const embedSessionRecovery: SessionRecovery = {
  // 埋め込みの中で、かつ権利を要求する API がある場合だけ導線に入る。
  // hasStorageAccess() を足してはならない。Chromium は CHIPS で cookie が通っている
  // 状態でも false を返すため、今 100% 動いている Edge に不要なダイアログが出る
  // (log/188 work-log/6 §4.1)。
  canRecover: () => isEmbeddedContext() && canRequestStorageAccess(),
  recover: requestStorageAccessOnce,
}
